import { ReactNode } from 'react';

export type SelectableOptionItem<T = string | number> = {
  label?: string | ReactNode;
  value: T;
  disabled?: boolean;
  Icon?: ReactNode;
};

export type OptionGroupLabel = { label: string | ReactNode };

export type CustomOption = {
  component: ReactNode;
};

export type OptionItem<T = string | number> = SelectableOptionItem<T> | OptionGroupLabel | CustomOption;

export const isSelectableOptionItem = <T>(item: OptionItem<T>): item is SelectableOptionItem<T> =>
  Object.hasOwn(item, 'value');

export const isOptionGroupLabel = <T>(item: OptionItem<T>): item is OptionGroupLabel =>
  !Object.hasOwn(item, 'value') && Object.hasOwn(item, 'label');
